import * as React from "react";
const SvgNavCheckSmallNone = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 18, height: 18, rx: 3, stroke: "currentColor", strokeWidth: 2 }));
export default SvgNavCheckSmallNone;
